import styled from "styled-components";

export const DashboardWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: auto 1fr;
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const DashboardHeader = styled.div`
    display: grid;
    width: 100%;
    height: 150px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const StatisticsItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border: 1px solid #F0F0F0;
    border-radius: 5px;
    background-size: cover;
    color: #EFEFEF;
    position: relative;
    overflow: hidden;
`;

export const StatisticsItemContent = styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
`;


export const StatisticsTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    letter-spacing: 2px;
    padding: 5px 0px;
    color: #CCCCCC;
`;

export const StatisticsContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    font-family: Helvetica, Arial, sans-serif;

    & .ant-progress-inner {
        background-color: rgba(255, 255, 255, 0.5);
    }
`;

export const Statistics = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
`;

export const StatisticsIcon = styled.div`
    color: rgba(255, 255, 255, 0.1);
    padding: 0px 10px;
    position: absolute;
    top: 0px;
    right: 0px;
`;

export const StatisticsText = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const StatisticsValue = styled.div`
    font-size: 36px;
    color: #EFEFEF;
    padding: 5px 0px;
`;

export const StatisticsDesc = styled.div`
    display: inline-block;
    font-size: 12px;
    text-align: center;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.15);
    padding: 3px 5px;
    overflow: hidden;
    margin: 20px 5px 0px 5px;
`;

export const DeviceMapWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
`;

export const DeviceDetailsSideBar = styled.div`
    position: absolute;
    right: 0px;
    top: 0px;
    width: 380px;
    height: 100%;
    z-index: 100;
    padding: 20px 20px;
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    color: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow-y: auto;
    transition: all 0.5s ease-in-out;
`;

export const DeviceName = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
`;

export const CloseButtonWrapper = styled.div`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
`;

export const DeviceInformation = styled.div`
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: minmax(50px, 1fr);
    align-items: stretch;
    justify-items: stretch;
    padding: 10px 0px 0px 0px;
    box-sizing: border-box;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const DeviceInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 60px;
`;

export const DeviceInfoItemLabel = styled.div`
    color: rgba(255, 255, 255, 0.75);
`;

export const DeviceInfoItemValue = styled.div`
    font-size: 14px;
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.95);
`;


export const DeviceRealtimeMetrics = styled.div`
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
`;
